import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BreadcrumbItem } from "@timeedit/ui-components";

interface NavigationState {
  breadCrumbs: BreadcrumbItem[];
}

const initialState: NavigationState = {
  breadCrumbs: [],
};

export const navigationSlice = createSlice({
  initialState,
  name: "navigation",
  reducers: {
    setBreadcrumbs(state, action: PayloadAction<BreadcrumbItem[]>) {
      // Only set current if we have breadcrumbs, and mark the last one as current (not clickable)
      state.breadCrumbs = action.payload.map((item, index) =>
        index === action.payload.length - 1 ? { ...item, current: true } : item
      );
    },
  },
});

export const { setBreadcrumbs } = navigationSlice.actions;
